import {
  createOutline,
  trash,
  informationCircleOutline,
  download,
  closeCircle,
} from "ionicons/icons";

export const editIcon = createOutline.replace(
  "<title>Create</title>",
  "<title>Edit</title>"
);
export const deleteIcon = trash.replace(
  "<title>Trash</title>",
  "<title>Delete</title>"
);
export const infoIcon = informationCircleOutline.replace(
  "<title>Information Circle</title>",
  "<title>Information</title>"
);
export const moveIcon = download.replace(
  "<title>Download</title>",
  "<title>Move</title>"
);
export const cancelIcon = closeCircle.replace(
  "<title>Close Circle</title>",
  "<title>Cancel</title>"
);
